import { useMemo } from 'react';

import { useEventCallback } from '~/hooks/useEventCallback';
import { api } from '~/redux/api/createApi';

const DEFAULT_PREFETCH_LIMIT = 5;

export const usePrefetchDocuments = () => {
  const prefetchDocumentFromVersion = api.usePrefetch(
    'getDocumentFromVersion',
    { force: false },
  );

  const prefetchDocuments = useEventCallback(
    (documentVersionIds: number[], limit?: number) => {
      if (documentVersionIds.length === 0) return;

      const maxLimit = limit ?? DEFAULT_PREFETCH_LIMIT;
      const idsToPrefetch = documentVersionIds.slice(0, maxLimit);
      idsToPrefetch.forEach((id) => {
        prefetchDocumentFromVersion(id);
      });
    },
  );

  return useMemo(() => ({ prefetchDocuments }), [prefetchDocuments]);
};
